import { render } from "./CheckboxGroupInput.vue?vue&type=template&id=9178a5ae&scoped=true"
import script from "./CheckboxGroupInput.vue?vue&type=script&lang=js"
export * from "./CheckboxGroupInput.vue?vue&type=script&lang=js"

import "./CheckboxGroupInput.vue?vue&type=style&index=0&id=9178a5ae&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9178a5ae"]])

export default __exports__